import { TableColumn } from '@revolut-internal/ui-kit'

export const columns: TableColumn<any>[] = [
  {
    Header: 'Account',
    accessor: 'account',
  },
  {
    Header: 'State',
    accessor: 'state',
  },
  {
    Header: 'Date',
    accessor: 'date',
  },
]
